import { Component, OnInit } from '@angular/core';
import { LayoutCss } from '../../modules/basico/layout-css/layout-css';
import { SharedService } from '../../common/shared.service';

@Component({
  selector: 'app-acesso-negado',
  templateUrl: './acesso-negado.component.html',
  styleUrls: ['./acesso-negado.component.css']
})
export class AcessoNegadoComponent implements OnInit {

  layout: LayoutCss
  constructor(
    private sheared: SharedService
  ) { }

  ngOnInit() {
    this.layout = this.sheared.layout;
  }

}
